import { initializeMobileMenu } from "./components/mobile-menu.js";
import { initializePageJump } from "./components/page-jump.js";
import { initializeServiceAreas } from "./components/service-areas.js";
import { refreshThemeControls } from "./theme.js";

const routes = {
  "/": {
    template: "/pages/home/home.html",
    initialize: async () => {
      const homeModule = await import("./pages/home/home.js");
      homeModule.initializeHome();
    },
  },
};

export async function navigateTo(url) {
  history.pushState(null, "", url);

  await renderCurrentRoute();
}

export async function renderCurrentRoute() {
  const route = routes[window.location.pathname] || routes["/"];
  const response = await fetch(route.template);
  const html = await response.text();
  document.querySelector("#app").innerHTML = html;
  await route.initialize?.();
  initializeServiceAreas();
  initializeMobileMenu();
  initializePageJump();
  refreshThemeControls();
}

export function initializeRouter() {
  document.addEventListener("click", (event) => {
    const link = event.target.closest("[data-link]");

    if (!link) {
      return;
    }

    event.preventDefault();

    navigateTo(link.getAttribute("href"));
  });

  window.addEventListener("popstate", renderCurrentRoute);

  renderCurrentRoute();
}
